var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-area" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("退款单据号")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [_vm._v(_vm._s(_vm.refundVoucher.no))])
      ])
    ]),
    _vm._v(" "),
    _vm.refundVoucher.settleProofId != -1
      ? _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("结算单号")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.refundVoucher.settleProofNo))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("退款状态")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [_vm._v(" " + _vm._s(_vm.refundVoucher.refundResultText))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("发票")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [_vm._v(_vm._s(_vm.refundVoucher.invoiceTypeText))])
      ])
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("收款方")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [_vm._v(_vm._s(_vm.refundVoucher.buyerName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("收款方式")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [_vm._v(_vm._s(_vm.refundVoucher.payWayText))])
      ])
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("退款金额")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", { staticClass: "font-red font16" }, [
          _c("b", [
            _vm._v(_vm._s(parseFloat(_vm.refundVoucher.amount).toFixed(2)))
          ]),
          _vm._v(" 元")
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.optionFlag != "shenHe"
      ? _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("留言")]),
          _vm._v(" "),
          _vm.optionFlag == "fuKuan"
            ? _c("div", { staticClass: "content" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.refundVoucher.memo,
                      expression: "refundVoucher.memo"
                    }
                  ],
                  staticStyle: { width: "320px", height: "90px" },
                  domProps: { value: _vm.refundVoucher.memo },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.refundVoucher, "memo", $event.target.value)
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.optionFlag == "chaKan"
            ? _c("div", { staticClass: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.refundVoucher.memo))])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.optionFlag != "shenHe"
      ? _c("div", [
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("审核结果")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(_vm._s(_vm.refundVoucher.auditStateText))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("审核描述")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(" " + _vm._s(_vm.refundVoucher.auditDesc))])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.optionFlag == "shenHe"
      ? _c("div", [
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("审核结果")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.refundVoucher.auditState,
                      callback: function($$v) {
                        _vm.$set(_vm.refundVoucher, "auditState", $$v)
                      },
                      expression: "refundVoucher.auditState"
                    }
                  },
                  _vm._l(_vm.auditStateList, function(auditStateInfo) {
                    return _c(
                      "el-radio",
                      { attrs: { label: auditStateInfo.value } },
                      [_c("span", [_vm._v(_vm._s(auditStateInfo.text))])]
                    )
                  })
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("审核描述")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.refundVoucher.auditDesc,
                    expression: "refundVoucher.auditDesc"
                  }
                ],
                staticStyle: { width: "320px", height: "90px" },
                domProps: { value: _vm.refundVoucher.auditDesc },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.refundVoucher,
                      "auditDesc",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("退款详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49f4d142", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f4d142","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/payment/RefundVoucherDetail.vue
// module id = 2103
// module chunks = 1